class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', () => {
      if (this.input.value.trim().length > 0 && this.predictiveSearchResults.innerHTML.trim() !== '') {
        this.open();
      }
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const searchMode = window.themeVariables?.settings?.searchMode || 'product,collection';
    const unavailableProducts = window.themeVariables?.settings?.searchUnavailableProducts || 'last';
    const predictiveSearchUrl = window.themeVariables?.routes?.predictiveSearchUrl || '/search/suggest';

    fetch(`${predictiveSearchUrl}?q=${encodeURIComponent(searchTerm)}&resources[type]=${searchMode}&resources[limit]=10&resources[options[unavailable_products]]=${unavailableProducts}&resources[options[fields]]=title,body,product_type,variants.title,variants.sku,vendor&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = '';
        this.addCloseButton();
        this.predictiveSearchResults.insertAdjacentHTML('beforeend', resultsMarkup);
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  addCloseButton() {
    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = '✕';
    closeBtn.setAttribute('aria-label', 'Suche schließen');
    closeBtn.style.cssText = 'position:absolute;top:8px;right:10px;background:none;border:none;font-size:18px;cursor:pointer;color:#666;padding:4px 8px;line-height:1;z-index:1;';
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.close();
      this.input.value = '';
      this.input.blur();
    });
    this.predictiveSearchResults.style.position = 'relative';
    this.predictiveSearchResults.appendChild(closeBtn);
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);